import React from 'react'
import { Span, Heading } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { TPaymentCategory } from '../../../../common/validations/paymentCategory'
import { CopyButton } from '../CopyButton'
import { Divider } from '../Divider'

import { useResolvePaymentCategory } from 'views/TerminateContract/hooks/usePaymentCategory'

interface BankAccountsPerCategoryProps {
  paymentCategories: TPaymentCategory[]
}

export const BankAccountsPerCategory: React.FC<
  BankAccountsPerCategoryProps
> = ({ paymentCategories }) => {
  const { t } = useTranslation(['payments'])
  const { resolvePaymentCategory } = useResolvePaymentCategory()

  if (paymentCategories.length === 0) {
    return (
      <>
        <Divider className="mt-8" />
        <Span>{t('payments:noAccountData')}.</Span>
      </>
    )
  }

  return paymentCategories.map((pc) => (
    <React.Fragment key={pc.category}>
      <Divider className="mt-8" />

      <div className="flex justify-between mt-8">
        <div>
          <Heading
            element="h3"
            size="m"
            bold
            key={pc.category}
            className="mb-2"
          >
            {resolvePaymentCategory(pc.category)}
          </Heading>

          <div className="flex flex-col gap-2">
            {pc.bankAccounts.map((ba) => (
              <Span key={ba.iban}>{`${ba.iban} (${ba.bankName})`}</Span>
            ))}
          </div>
        </div>

        {/* only copy the first IBAN if there are several */}
        <CopyButton copyText={pc.bankAccounts[0].iban} />
      </div>
    </React.Fragment>
  ))
}
